import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../interactions/interactions';
import css from './control-close.css';

const ControlClose = forwardRef(
  (
    {
      ariaLabel,
      disabled,
      fullScreen,
      handleClick,
      inverse,
      className,
      ...otherProps
    },
    ref,
  ) => (
    <button
      className={classnames(
        css['ds-control-close'],
        {
          [css['ds-control-close--full-screen']]: fullScreen,
          [css['ds-control-close--inverse']]: inverse,
        },
        className,
      )}
      onClick={handleClick}
      aria-label={ariaLabel}
      disabled={disabled}
      type='button'
      ref={ref}
      {...otherProps}
    >
      <svg width='100%' viewBox='5 5 14 14' xmlns='http://www.w3.org/2000/svg'>
        <path
          className={classnames(css['path-background'], {
            [css['path-background--disabled']]: disabled,
          })}
          d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        />
      </svg>
    </button>
  ),
);

ControlClose.displayName = 'ControlClose';

ControlClose.defaultProps = {
  ariaLabel: 'Close',
  disabled: false,
  fullScreen: false,
  handleClick: null,
  inverse: false,
  className: '',
};

ControlClose.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  fullScreen: PropTypes.bool,
  handleClick: PropTypes.func,
  inverse: PropTypes.bool,
  className: PropTypes.string,
};

export default ControlClose;
